module.exports = __webpack_public_path__ + "img/wz-8-5-5.dc2a748b.jpg";